import { render, staticRenderFns } from "./AStaffDetailRepair.vue?vue&type=template&id=7634d983&scoped=true"
import script from "./AStaffDetailRepair.vue?vue&type=script&lang=js"
export * from "./AStaffDetailRepair.vue?vue&type=script&lang=js"
import style0 from "./AStaffDetailRepair.vue?vue&type=style&index=0&id=7634d983&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7634d983",
  null
  
)

export default component.exports